"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roundNumber = exports.formatLabel = exports.formatError = exports.extractAwyesId = exports.escapeValue = exports.createCmsId = exports.convertStringToFloat = exports.buildAwyesId = void 0;

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _require = require('nanoid'),
    customAlphabet = _require.customAlphabet;

var nanoid = customAlphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZ', 5);

var buildAwyesId = function buildAwyesId(_ref) {
  var id = _ref.id,
      typeName = _ref.typeName;
  return id !== null && id !== void 0 && id.length && typeName !== null && typeName !== void 0 && typeName.length ? window.btoa("".concat(typeName, ":").concat(id)) : undefined;
};

exports.buildAwyesId = buildAwyesId;

var extractAwyesId = function extractAwyesId(awyesId) {
  if (!awyesId) return;

  var _window$atob$split = window.atob(awyesId).split(':'),
      _window$atob$split2 = _toArray(_window$atob$split),
      typeName = _window$atob$split2[0],
      rest = _window$atob$split2.slice(1);

  return {
    typeName: typeName,
    id: rest.join(':')
  };
};

exports.extractAwyesId = extractAwyesId;

var createCmsId = function createCmsId() {
  return "".concat(new Date().toISOString().match(/^\d{2}(\d{2})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/).slice(1).join('')).concat(nanoid());
};

exports.createCmsId = createCmsId;

var formatLabel = function formatLabel() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var result = str.trim().replace(/^Awyes/, '').replace(/([^A-Z])([A-Z])/g, '$1 $2').toLowerCase().replace(/(^|\s+)([a-z])/gi, function (_) {
    var space = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var letter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return "".concat(space).concat(letter.toUpperCase());
  });
  return result === 'Id' ? 'ID' : result;
};

exports.formatLabel = formatLabel;

var formatError = function formatError(error) {
  return error && error !== true ? error : undefined;
};

exports.formatError = formatError;

var escapeValue = function escapeValue(value) {
  return "".concat(value !== null && value !== void 0 ? value : '').replace(/\n/g, ' ').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/>/g, '&gt;').replace(/</g, '&lt;');
};

exports.escapeValue = escapeValue;

var convertStringToFloat = function convertStringToFloat(str) {
  return parseFloat("".concat(str).replace(/[^\d.]/g, ''));
};

exports.convertStringToFloat = convertStringToFloat;

var multiplyByTenToThePower = function multiplyByTenToThePower(value, dp) {
  return value + 'e' + dp;
};

var divideByTenToThePower = function divideByTenToThePower(value, dp) {
  return value + 'e-' + dp;
};

var roundNumber = function roundNumber(value) {
  var dp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return isNaN(value) ? value : Number(divideByTenToThePower(Math.round(multiplyByTenToThePower(value, dp)), dp));
};

exports.roundNumber = roundNumber;

var convertToPence = function convertToPence(rawPrice) {
  var price = rawPrice !== null && rawPrice !== void 0 ? rawPrice : 0;

  if (price.constructor !== Number) {
    price = parseFloat("".concat(price).replace(/[^\d.]/g, ''));
  }

  return "".concat(roundNumber(price * 100)).padStart(10, '0');
};

var convertToSlug = function convertToSlug(raw) {
  return (raw !== null && raw !== void 0 ? raw : '').trim().toLowerCase().replace(/[^a-z0-9\s_/-]/gi, '-').replace(/[-_\s]+/g, '-');
};

var convertToParam = function convertToParam(raw) {
  return (raw !== null && raw !== void 0 ? raw : '').trim().toLowerCase().replace(/[^a-z0-9\s_-]/gi, '-').replace(/[-_\s]+/g, '-');
};

var convertToDate = function convertToDate(raw) {
  return new Date(raw).toISOString();
};

exports.fieldFormatters = {
  PENCE: convertToPence,
  SLUGIFY: convertToSlug,
  PARAMIFY: convertToParam,
  DATETIME: convertToDate
};